import { useState, useEffect, useRef } from 'react';

const BUILD_VERSION = process.env.REACT_APP_BUILD_VERSION;
const CHECK_INTERVAL_MS = 5 * 60 * 1000; // 5 minutes

const clearCachesOnVersionChange = async () => {
  if ('caches' in window) {
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map((name) => caches.delete(name)));
  }
  localStorage.removeItem('persist:root');
};

export function useVersionCheck(enabled) {
  const [newVersionAvailable, setNewVersionAvailable] = useState(false);
  const [serverVersion, setServerVersion] = useState(null);
  const intervalRef = useRef(null);

  const checkVersion = async () => {
    // Do not run in local development or when no version was injected at build time.
    if (!BUILD_VERSION || process.env.NODE_ENV === 'development') return;

    try {
      const resp = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
      if (!resp.ok) return;
      const { version } = await resp.json();
      if (version && version !== BUILD_VERSION) {
        // Clear caches immediately so any reload (F5, system, or button) gets fresh assets.
        await clearCachesOnVersionChange();
        setServerVersion(version);
        setNewVersionAvailable(true);
      }
    } catch {
      // Connectivity issues should not trigger the banner.
    }
  };

  useEffect(() => {
    if (!enabled) return;

    checkVersion();
    intervalRef.current = setInterval(checkVersion, CHECK_INTERVAL_MS);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [enabled]); // eslint-disable-line react-hooks/exhaustive-deps

  return { newVersionAvailable, serverVersion };
}
